import { IAxiosError } from '@/@types/AxiosError';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { useToast } from '@/common/hooks/useToast';

import { postRemoveDebitNotes } from '../services/postRemoveDebitNotes';
import { postUnlinkDebitNotes } from '../services/postUnlinkDebitNotes';

export function useRequestApprovalRemoveDebitNotes(userLogged = false) {
  const { t } = useTranslation('invoicing/requestApprovalReview');
  const { toast } = useToast();

  const {
    mutateAsync: mutatePostRemoveDebitNotes,
    isLoading: isLoadingMutatePostRemoveDebitNotes,
  } = useMutation({
    mutationKey: ['remove-debit-notes'],
    mutationFn: postRemoveDebitNotes,
    onSuccess: () => toast.success(t('successRemovedDebitNotes')),
    onError: (errorRequest: IAxiosError) => {
      toast.error(
        t('errorOnUnlinkDebitNotes'),
        errorRequest?.response?.data?.friendlyMessage,
        {
          toastId: 'unlink-debit-notes',
        },
      );
    },
  });

  const {
    mutateAsync: mutateUnlinkDebitNotes,
    isLoading: isLoadingMutateUnlinkRemoveDebitNotes,
  } = useMutation({
    mutationKey: ['remove-debit-notes'],
    mutationFn: postUnlinkDebitNotes,
    onSuccess: () => toast.success(t('successRemovedDebitNotes')),
    onError: (errorRequest: IAxiosError) => {
      toast.error(
        t('errorOnUnlinkDebitNotes'),
        errorRequest?.response?.data?.friendlyMessage,
        {
          toastId: 'unlink-debit-notes',
        },
      );
    },
  });

  return {
    removeDebitNotes: userLogged
      ? mutateUnlinkDebitNotes
      : mutatePostRemoveDebitNotes,
    isRemovingDebitNotes: userLogged
      ? isLoadingMutateUnlinkRemoveDebitNotes
      : isLoadingMutatePostRemoveDebitNotes,
  };
}
